/*
 * $Id:: index.js 2021/03/02 11:11 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { globals as globalsSlice } from '../../app/globalsSlice';
import { userCan } from '../../common/utils/service';
import HomePageCard from '../../components/HomePageCard/HomePageCard';
import PageTitle from '../../components/PageTitle';
import { getLocale, t } from '../../providers';
import { me as meSlice } from '../AuthenticatedPage/authenticationSlice';
import utils from './utils';

const useStyles = makeStyles((_theme) => ({
    tabs: {
        '& .MuiTabs-scroller::-webkit-scrollbar-thumb': {
            backgroundColor: 'unset',
        },
        '& .MuiTab-root': {
            minWidth: '100px',
        },
    },
    tabContainer: {
        width: '100%',
    },
    cardTable: {
        '@media (max-width:960px)': {
            marginRight: 'unset',
        },
    },
    topBarLeft: {
        fontSize: '0.875rem',
        fontWeight: '100',
        color: '#4D4D4D',
        paddingTop: '3px',
        marginTop: '5px',
    },
    refreshButton: {
        color: '#3F5E20',
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '16px',
        letterSpacing: '0.5px',
        textAlign: 'left',
        padding: '0px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    servicesList: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: 0,
        padding: 0,
        gap: '16px 24px',
        boxSizing: 'border-box',
        '@media (max-width:595px)': {
            justifyContent: 'center',
        },
    },
}));

const HomePage = () => {
    const classes = useStyles();
    const me = useSelector(meSlice);

    const [user, setUser] = useState({ fullName: me.fullName, hasApplications: me.hasApplications });
    const [tabs, setTabs] = useState([]);
    const [userIsChildAccount, setUserIsChildAccount] = useState(false);
    const history = useHistory();
    const location = useLocation();

    const items = [...utils['auth']];
    const { userType, authorities } = me || {};
    const selectedLanguage = getLocale();
    const { globals } = useSelector(globalsSlice) || {};

    const navigateTo = (event, path, external) => {
        event.preventDefault();

        if (path && external) {
            let newPath = path;
            if (!!newPath && !newPath.startsWith('http')) newPath = globals.ipo['fo.url'].concat(globals.ipo[path]);
            if (newPath.indexOf('?') >= 0) {
                newPath += `&lang=${selectedLanguage}`;
            } else {
                newPath += `?lang=${selectedLanguage}`;
            }
            if (!!newPath) window.open(newPath, '_blank');
        } else {
            if (path && location.pathname !== path) {
                history.push(path);
            }
        }
    };
    const authItems = items.filter((item) => !item.cannotAccess || !item.cannotAccess(userType, authorities));

    const serviceList =
        items &&
        !!items.length &&
        authItems.map((item, index) => (
            <HomePageCard key={index} item={item} navigateTo={navigateTo} userType={userType} authorities={authorities} />
        ));

    useEffect(() => {
        const { authorities, fullName, personType, hasApplications, childFullName } = me;
        setUser({ fullName: fullName || '', userType: personType || '', hasApplications: hasApplications });
        if (childFullName !== '') {
            setUserIsChildAccount(true);
        }
        const allowedTabs = [];
        // if (userCan(authorities, 'ROLE_TRADEMARKS')) allowedTabs.push(TRADEMARKS);
        // if (userCan(authorities, 'ROLE_DESIGNS')) allowedTabs.push(DESIGNS);

        if (allowedTabs.length > 0) {
            // allowedTabs.push(PATENTS);
            setTabs(allowedTabs); //set tabs depending on tabs allowed based on authorities role
        }
    }, [me]);

    const capitalizeStrint = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map((name) => name.charAt(0).toUpperCase() + name.substring(1))
            .join(' ');
    };

    return (
        <div>
            <PageTitle
                title={
                    !userIsChildAccount
                        ? `${capitalizeStrint(me.fullName || `${me.firstName} ${me.surName}`)}, ${t('welcome.to.user.area')}`
                        : t('child.account.welcome.to.user.area', {
                              user: capitalizeStrint(me.childFullName),
                              parent: `${capitalizeStrint(`${me.fullName}`)}`,
                          })
                }
                details={
                    !userIsChildAccount
                        ? t('refer.online.services')
                        : t('child.account.refer.online.services', { user: `${capitalizeStrint(`${me.fullName}`)}` })
                }
            />
            {
                <div className={classes.servicesList} style={{ clear: 'both' }}>
                    {serviceList}
                </div>
            }
        </div>
    );
};

export default HomePage;
